import React, { useState, useEffect, useRef } from "react";
import Header from "../../component/menu/Header";
import { constants } from "../../constant/constants";
import SideMenu from "../../component/menu/SideMenu";
import useUserStore from "../../stores/store";
import OrderReportComponent from "../../component/restaurants/reports/OrderReportComponent";
import { ReportService } from "../../services/reports-services";
import CustomLoader from "../../component/menu/CustomLoader";

export default function OrderReport() {
  const { user, restaurantId, showNotification, networkCall, setNetworkCall } = useUserStore();
  const [ordersSummary, setOrdersSummary] = useState({});
  const [ordersReportList, setOrdersReportList] = useState(null);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalItem, setTotalItem] = useState(0);
  const [ordersFilter, setOrdersFilter] = useState({
    restaurantId: restaurantId,
    orderNo: "",
    fromDateTime: "",
    toDateTime: "",
    orderType: "",
    paymentType: "",
  });
  const [isFilterClear, setIsFilterClear] = useState(false);
  const isFetching = useRef(false);

  async function fetchOrdersReportList(filter) {
    setNetworkCall(true);
    try {
      const orders = await ReportService.getOrderReportList(
        filter,
        user.token.token
      );
      setOrdersReportList(ReportService.formatDataList(orders.data));
      setPage(orders.page);
      setPerPage(orders.perPage);
      setTotalItem(orders.total);
      setNetworkCall(false);
    } catch (err) {
      showNotification("Something went wrong in serverside. Try again later.");
      setNetworkCall(false);
      return;
    }
  }

  useEffect(() => {
    async function fetchData() {
      if (isFetching.current) return;
      isFetching.current = true;

      try {
        const tempFilter = { ...ordersFilter, page, perPage };
        await fetchOrdersReportList(tempFilter);
      } catch (err) {
        console.error("Error fetching:", err);
      } finally {
        isFetching.current = false;
      }
    }

    fetchData();
  }, [page, perPage]);

  /** init **/
  useEffect(() => {
    async function fetchSummaryReport() {
      try {
        const summaryReport = await ReportService.getOrderReportSummary(
          restaurantId,
          user.token.token
        );
        setOrdersSummary(summaryReport.data);
      } catch (error) {
        console.error("Error fetching report:", error);
        showNotification("Something went wrong. Try again later.");
        return;
      }
    }

    if (restaurantId) {
      fetchSummaryReport();
    }
  }, [restaurantId]);

  useEffect(() => {
    async function fetchData() {
      if (isFilterClear) {
        await fetchOrdersReportList(ordersFilter);
        setIsFilterClear(false);
      }
    }

    fetchData();
  }, [isFilterClear]);

  function onHandleFilterData() {
    if (page !== 1 || perPage !== 10) {
      setPage(1);
      setPerPage(10);
    }
    const tempFilter = { ...ordersFilter, page: 1, perPage: 10 };
    fetchOrdersReportList(tempFilter);
  }

  function onHandlePageChange(page, pageSize) {
    setPage(page);
    setPerPage(pageSize);
  }

  function onHandlePageSizeChange(current, size) {
    setPerPage(size);
  }

  function onHandleDownloadReport() {
    const { page, perPage, ...params } = ordersFilter;
    setNetworkCall(true);
    ReportService.getDownloadOrdersReport(params, user.token.token).then(
      (res) => {
        if (res.data) {
          setNetworkCall(false);
          ReportService.downloadPDF(res.data, "orders-report.pdf");
          showNotification('Orders report downloaded successfully!', false);
        } else {
          setNetworkCall(false);
          showNotification("Failed to download the report");
          return;
        }
      }
    );
  }

  return (
    <section>
      <div className="flex flex-col">
        <CustomLoader />
        <Header title={""} menu={""} currentMenuKey={"T_6_S_6_L_5"} />
        <div className="flex flex-row bg-prewhite px-[12%]">
          <SideMenu title={`Sale Report`} menu={""} />
        </div>
        <div className=" mt-[80px] ml-[80px] px-[50px]">
          <h1 className="pt-[50px] pb-[20px] font-bold text-black text-[24px] leading-[24px] cursor-default">
            {constants.MENU.REPORTS[5]}
          </h1>

          <OrderReportComponent
            summaryData={ordersSummary}
            reportData={ordersReportList}
            setOrdersFilter={setOrdersFilter}
            handleFilterApply={onHandleFilterData}
            page={page}
            perPage={perPage}
            setPerPage={setPerPage}
            total={totalItem}
            handlePageChange={onHandlePageChange}
            handlePageSizeChange={onHandlePageSizeChange}
            setIsFilterClear={setIsFilterClear}
            handleDownload={onHandleDownloadReport}
            loading={networkCall}
          />
        </div>
      </div>
    </section>
  );
}
